import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const VideoTestimonialCard = ({ testimonial, onPlay }) => {
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlay = () => {
    setIsPlaying(true);
    onPlay(testimonial);
  };

  const handleShare = () => {
    const message = `Check out this amazing success story from Nitin Online Hub! ${testimonial?.name} from ${testimonial?.city} won ₹${testimonial?.winAmount?.toLocaleString('en-IN')}! Join me on this trusted platform.`;
    window.open(`https://wa.me/?text=${encodeURIComponent(message)}`, '_blank');
  };

  return (
    <div className="bg-card rounded-card shadow-subtle hover:shadow-royal transition-royal overflow-hidden group">
      {/* Video Thumbnail */}
      <div className="relative aspect-video bg-muted">
        <Image
          src={testimonial?.thumbnail}
          alt={`${testimonial?.name} testimonial video`}
          className="w-full h-full object-cover"
        />
        
        {/* Play Button Overlay */}
        <div className="absolute inset-0 bg-black/30 flex items-center justify-center group-hover:bg-black/40 transition-royal">
          <button
            onClick={handlePlay}
            className="w-16 h-16 bg-primary/90 hover:bg-primary rounded-full flex items-center justify-center shadow-royal hover:scale-110 transition-royal"
            aria-label={`Play ${testimonial?.name}'s testimonial`}
          >
            <Icon name="Play" size={24} color="white" className="ml-1" />
          </button>
        </div>

        {/* Duration Badge */}
        <div className="absolute bottom-3 right-3 bg-black/70 text-white px-2 py-1 rounded text-xs font-medium">
          {testimonial?.duration}
        </div>

        {/* Winner Badge */}
        <div className="absolute top-3 left-3 bg-gradient-royal text-white px-3 py-1 rounded-full text-xs font-bold flex items-center space-x-1">
          <Icon name="Trophy" size={14} />
          <span>Winner</span>
        </div>
      </div>
      {/* Content */}
      <div className="p-6">
        {/* Player Info */}
        <div className="flex items-center space-x-3 mb-4">
          <div className="w-12 h-12 bg-gradient-royal rounded-full flex items-center justify-center">
            <Icon name="User" size={20} color="white" />
          </div>
          <div>
            <h3 className="font-heading font-semibold text-text-primary">{testimonial?.name}</h3>
            <p className="text-sm text-text-secondary">{testimonial?.city}, {testimonial?.state}</p>
          </div>
        </div>

        {/* Win Amount */}
        <div className="mb-4">
          <div className="text-2xl font-heading font-bold text-gradient-royal mb-1">
            ₹{testimonial?.winAmount?.toLocaleString('en-IN')}
          </div>
          <p className="text-sm text-text-secondary">Won playing {testimonial?.game}</p>
        </div>

        {/* Quote Preview */}
        <blockquote className="text-text-primary italic mb-4 line-clamp-2">
          "{testimonial?.quote}"
        </blockquote>

        {/* Stats */}
        <div className="flex items-center justify-between text-sm text-text-secondary mb-4">
          <div className="flex items-center space-x-1">
            <Icon name="Calendar" size={14} />
            <span>{testimonial?.date}</span>
          </div>
          <div className="flex items-center space-x-1">
            <Icon name="Eye" size={14} />
            <span>{testimonial?.views} views</span>
          </div>
        </div>

        {/* Actions */}
        <div className="flex space-x-2">
          <Button
            variant="default"
            size="sm"
            onClick={handlePlay}
            iconName="Play"
            iconPosition="left"
            className="flex-1"
          >
            Watch Story
          </Button>
          <Button
            variant="outline"
            size="sm"
            onClick={handleShare}
            iconName="Share"
            className="px-3"
          />
        </div>
      </div>
    </div>
  );
};

export default VideoTestimonialCard;